import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';

const formatDateTime = (value) => {
  if (!value) return 'N/A';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString();
};

const ArchivedReportsDialog = ({ open, reports, datasetMap, onClose, onUnarchive }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Archived reports</DialogTitle>
      <DialogContent dividers>
        {reports.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No archived reports yet.
          </Typography>
        ) : (
          <List disablePadding>
            {reports.map((report, index) => (
              <React.Fragment key={report.id}>
                <ListItem
                  secondaryAction={
                    <Button size="small" onClick={() => onUnarchive(report)}>
                      Unarchive
                    </Button>
                  }
                >
                  <ListItemText
                    primary={report.name}
                    secondary={
                      <Stack spacing={0.5}>
                        <Typography variant="caption" color="text.secondary">
                          {datasetMap.get(report.baseDataset) || report.baseDataset || 'N/A'}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          Updated {formatDateTime(report.updatedAt)}
                        </Typography>
                      </Stack>
                    }
                    secondaryTypographyProps={{ component: 'div' }}
                  />
                </ListItem>
                {index < reports.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close archived reports</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ArchivedReportsDialog;
